import DeleteAssetModal from './DeleteAssetModal';
import TermsPage from './TermsPage';
import Detail from './Detail';

export default {
  DeleteAssetModal,
  TermsPage,
  Detail
};
